var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypeOfVariationinShade(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.858,
    y1: 0.111,
    x2: 0.162,
    y2: 0.923,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bccff3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee7d11"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16870",
    "data-name": "Rectangle 16870",
    width: 18.176,
    height: 18.182,
    fill: "#ee7d11"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11889",
    "data-name": "Group 11889",
    transform: "translate(-1028.184 -146)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16869",
    "data-name": "Rectangle 16869",
    width: 36,
    height: 36,
    rx: 8,
    transform: "translate(1028.184 146)",
    opacity: 0.2,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11841",
    "data-name": "Group 11841",
    transform: "translate(1035.306 154.909)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11840",
    "data-name": "Group 11840",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37767",
    "data-name": "Path 37767",
    d: "M3.695,13.464,4.732,14.48a.665.665,0,0,1,.751-.5.65.65,0,0,1,.626.592,5.308,5.308,0,0,1-.69,3.053,2.036,2.036,0,0,1-.309.369A.676.676,0,0,1,4.182,18a.7.7,0,0,1-.1-.928c.478-.69.479-.691-.116-1.287C3.309,15.131,2.645,14.483,2,13.816a.3.3,0,0,0-.461-.05c-.13.094-.256.193-.382.293a.7.7,0,0,1-.973-.054.689.689,0,0,1,.035-.972,3.165,3.165,0,0,1,2.34-.923c1.239-.033,2.479-.017,3.719-.025.662,0,1.325-.014,1.987-.024a1.88,1.88,0,0,0,.21-.022L6.132,9.705c-.014.2-.032.454-.048.7-.03.486-.314.79-.726.775a.713.713,0,0,1-.671-.845,8.512,8.512,0,0,1,.526-2.775A4.106,4.106,0,0,1,8.272,4.979,13.731,13.731,0,0,1,10.8,4.7c1.125-.04,2.252.007,3.379.017h.271l-1-.987a.672.672,0,0,1-.742.477.642.642,0,0,1-.624-.561,4.977,4.977,0,0,1,.67-3.105,2.19,2.19,0,0,1,.3-.342.677.677,0,0,1,.949-.006.7.7,0,0,1,.078.93c-.468.645-.468.645.1,1.214.662.663,1.33,1.321,1.984,1.992.153.157.285.2.463.073.123-.087.25-.17.368-.263a.705.705,0,0,1,1,.046.691.691,0,0,1-.064.992,3.032,3.032,0,0,1-2,.843c-.924.066-1.852.08-2.779.094-1.079.016-2.157.007-3.236.01a1.3,1.3,0,0,0-.184.022l2.3,2.277a.43.43,0,0,0,.023-.122c.017-.34.017-.682.044-1.021a.693.693,0,0,1,.691-.658.675.675,0,0,1,.686.66,8.418,8.418,0,0,1-.757,3.807,4.125,4.125,0,0,1-3.109,2.191,14.027,14.027,0,0,1-2.284.207c-1.1.027-2.2-.01-3.294-.02H3.695m7.939-3.283a1.2,1.2,0,0,0-.109-.146Q9.841,8.348,8.15,6.669a.317.317,0,0,0-.283-.055A2.483,2.483,0,0,0,6.622,7.842a.316.316,0,0,0,.05.284c1.116,1.13,2.242,2.251,3.362,3.377a.233.233,0,0,0,.32.053,2.7,2.7,0,0,0,1.214-1.229c.021-.042.039-.086.065-.146",
    transform: "translate(0 0)",
    fill: "#ee7d11"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeOfVariationinShade);
export default __webpack_public_path__ + "static/media/typeOfVariationinShade.f40614bed7948ffccb8a84d5ff69909f.svg";
export { ForwardRef as ReactComponent };